import { useEffect, useState } from 'react'

export function useInViewOnce<T extends Element>(
  rootMargin = '0px',
): [(node: T | null) => void, boolean] {
  const [node, setNode] = useState<T | null>(null)
  const [inView, setInView] = useState(() => typeof IntersectionObserver === 'undefined')

  useEffect(() => {
    if (!node || inView) {
      return undefined
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true)
        }
      },
      { rootMargin },
    )
    observer.observe(node)
    return () => {
      observer.disconnect()
    }
  }, [node, inView, rootMargin])

  return [setNode, inView]
}
